import { createRoot } from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import { replayIntegration } from "@sentry/react";
import structuredClone from "@ungap/structured-clone";

if (!("structuredClone" in window)) {
  // @ts-ignore
  window.structuredClone = structuredClone;
}

// @ts-ignore
"hasOwn" in Object || (Object.hasOwn = Object.call.bind(Object.hasOwnProperty));

(function (w) {
  // @ts-ignore
  var isFunction =
      // @ts-ignore
      w.isFunction ||
      // @ts-ignore
      (w.isFunction = function (x) {
        return typeof x === "function";
      }),
    // @ts-ignore
    has =
      // @ts-ignore
      w.has ||
      // @ts-ignore
      (w.has = function (o, p) {
        var e = p in o;
        return {
          value: e && (e = o[p]) && true,
          refer: e,
          valueOf: function () {
            return this.value;
          },
        };
      }),
    Polyfill =
      // @ts-ignore
      w.PolyfillMethod ||
      // @ts-ignore
      (w.PolyfillMethod = function (o, p, x) {
        var e = has(o, p);
        if (e && (e = isFunction(e.refer)) === false) {
          o[p] = x;
        }
        return e;
      }),
    theProto = w.Object.prototype;

  Polyfill(theProto, "hasOwnProperty", function (x) {
    var o,
      e = this,
      p = String(x);
    return p in e && ((o = e.__proto__ || e.constructor.prototype), p in o === false || e[p] !== o[p]);
  });
})(window);

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://e33df79c945bd8be291730a3d66c4f6a@o4506673859919872.ingest.sentry.io/4506673862213632",
    enableLogs: true,
    release: "DishForagerDashboard@1.7.0",
    tracePropagationTargets: ["localhost", /^https:\/\/dishforager\.com\/api/],
    integrations: [
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [
          "/api/makebooking/getForDate",
          "/api/makebooking/getEventAvailability",
          "/api/makebooking/getNextAvailable",
          "/api/makebooking/getBooking",
          "/api/makebooking/amendBooking",
          "/api/makebooking/book",
          "/api/makebooking/hold",
          "/api/makebooking/getClientSetupIntent",
          "/api/makebooking/getClientPaymentIntent",
          "/api/weblocation/getlocation",
        ],
        networkRequestHeaders: ["X-Custom-Header"],
        networkResponseHeaders: ["X-Custom-Header"],
        networkCaptureBodies: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);

if (import.meta.env.MODE === "web" || import.meta.env.MODE === "development") {
  serviceWorkerRegistration.register();
  import("./App").then(({ default: Component }) => root.render(<Component />));
}

if (import.meta.env.MODE === "dashboard") {
  serviceWorkerRegistration.register();
  import("./DashboardApp").then(({ default: Component }) => root.render(<Component />));
}

if (import.meta.env.MODE === "bookings") {
  serviceWorkerRegistration.unregister();
  import("./BookingApp")
    .then(({ default: Component }) => {
      sessionStorage.removeItem("booking-import-retry");
      root.render(<Component />);
    })
    .catch(async (error) => {
      console.error("Failed to load booking module:", error);
      const hasRetried = sessionStorage.getItem("booking-import-retry");
      if (!hasRetried) {
        sessionStorage.setItem("booking-import-retry", "1");
        if ("caches" in window) {
          const names = await caches.keys();
          await Promise.all(names.map((n) => caches.delete(n)));
        }
        window.location.reload();
      }
    });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
